/**
 * DocumentList Component
 * Reusable list container for displaying documents
 */

import type { ProspectDocument } from '../../../../../types/prospect-media';
import { DocumentItem } from './DocumentItem';
import './DocumentList.css';

interface DocumentListProps {
  documents: ProspectDocument[];
  loading?: boolean;
  downloadingDocumentId?: string | null;
  onDocumentClick: (document: ProspectDocument) => void;
  onDeleteClick: (documentId: string) => void;
  emptyText?: string;
  emptySubtext?: string;
}

export function DocumentList({
  documents,
  loading = false,
  downloadingDocumentId = null,
  onDocumentClick,
  onDeleteClick,
  emptyText = 'No documents yet',
  emptySubtext,
}: DocumentListProps) {
  if (loading) {
    return (
      <div className="document-list__loading">
        <p>Loading documents...</p>
      </div>
    );
  }

  if (documents.length === 0) {
    return (
      <div className="document-list__empty">
        <p className="document-list__empty-text">{emptyText}</p>
        {emptySubtext && (
          <p className="document-list__empty-subtext">{emptySubtext}</p>
        )}
      </div>
    );
  }

  return (
    <div className="document-list">
      {documents.map((document, index) => (
        <div key={document.id}>
          <DocumentItem
            document={document}
            onDocumentClick={onDocumentClick}
            onDeleteClick={onDeleteClick}
            isDownloading={downloadingDocumentId === document.id}
          />
          {index < documents.length - 1 && (
            <div className="document-list__divider" />
          )}
        </div>
      ))}
    </div>
  );
}
